import { createAction } from "@reduxjs/toolkit";

const SET_LANGUAGE = "SET_LANGUAGE";
const SET_THEME = "SET_THEME";
const UPLOAD_FILES = "UPLOAD_FILES";
const GET_TICKET_LIST_CONFIG = "GET_TICKET_LIST_CONFIG";
const SIGN_UP = "SIGN_UP";
const GET_TICKETS_LIST = "GET_TICKETS_LIST";
const SYNC_TICKERS = "SYNC_TICKERS";
const SIGN_UP_USER = "SIGN_UP_USER";
const COMPLETE_PROFILE = "COMPLETE_PROFILE";
const UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE";
const SIGN_IN_USER = "SIGN_IN_USER";
const GET_USER = "GET_USER";
const UPDATE_USER = "UPDATE_USER";
const UPDATE_EMAIL = "UPDATE_EMAIL";
const DELETE_ACCOUNT = "DELETE_ACCOUNT";
const LOGOUT = "LOGOUT";
const CLEAR_USER = "CLEAR_USER";
const GET_SUBSCRIPTIONS = "GET_SUBSCRIPTIONS";
const UPDATE_USER_SUBSCRIPTION = "UPDATE_USER_SUBSCRIPTION";
const UPDATE_TICKET = "UPDATE_TICKET";
const DELETE_TICKET = "DELETE_TICKET";

export const ACTION_SET_LANGUAGE = createAction(SET_LANGUAGE);
export const ACTION_SET_THEME = createAction(SET_THEME);
export const ACTION_UPLOAD_FILES = createAction(UPLOAD_FILES);
export const ACTION_GET_TICKET_LIST_CONFIG = createAction(GET_TICKET_LIST_CONFIG);
export const ACTION_SIGN_UP = createAction(SIGN_UP);
export const ACTION_GET_TICKETS_LIST = createAction(GET_TICKETS_LIST);
export const ACTION_SYNC_TICKERS = createAction(SYNC_TICKERS);
export const ACTION_SIGN_UP_USER = createAction(SIGN_UP_USER);
export const ACTION_COMPLETE_PROFILE = createAction(COMPLETE_PROFILE);
export const ACTION_UPDATE_USER_PROFILE = createAction(UPDATE_USER_PROFILE);
export const ACTION_SIGN_IN_USER = createAction(SIGN_IN_USER);
export const ACTION_GET_USER = createAction(GET_USER);
export const ACTION_UPDATE_USER = createAction(UPDATE_USER);
export const ACTION_UPDATE_EMAIL = createAction(UPDATE_EMAIL);
export const ACTION_DELETE_ACCOUNT = createAction(DELETE_ACCOUNT);
export const ACTION_LOGOUT = createAction(LOGOUT);
export const ACTION_CLEAR_USER = createAction(CLEAR_USER);
export const ACTION_GET_SUBSCRIPTIONS = createAction(GET_SUBSCRIPTIONS);
export const ACTION_UPDATE_USER_SUBSCRIPTION = createAction(UPDATE_USER_SUBSCRIPTION);
export const ACTION_UPDATE_TICKET = createAction(UPDATE_TICKET);
export const ACTION_DELETE_TICKET = createAction(DELETE_TICKET);